import React from 'react';
import { Navigate } from 'react-router';

import { LoadingSpinner, VStack } from '@adc/parallax-component-library';

import { useLandingRoute } from '../../hooks/useLandingRoute';
import { useAppSelector } from '../../reducers/hooks';
import NotFound from './NotFound';

export default function LandingRedirect() {
  const { isLoaded } = useAppSelector((state) => state.capabilities);
  const landingRoute = useLandingRoute();

  if (!isLoaded) {
    return (
      <VStack alignItems="center" justifyContent="center" flexGrow={1}>
        <LoadingSpinner testID="landing-redirect-loading-spinner" />
      </VStack>
    );
  }

  return landingRoute ? <Navigate to={landingRoute} replace /> : <NotFound />;
}
